module.exports = "/images/cover-10.jpg";